<breadcrumb [endText]="configName + ' Config'" [navigations]="breadcrumbNavs" />
<div class="m-5">
  <div class="font-medium text-xl mb-2">
    {{configName}} Config
  </div>
  <hr />
  <div class="mt-5">
    <div class="text-sm mb-8 text-zinc-500">
      Below are the required fields for creating a new {{ configName.toLocaleLowerCase() }}.
    </div>
    <div class="grid grid-cols-2 w-fit gap-y-1">
      Enter Name:
      <input [(ngModel)]="name" type="text" placeholder="Name" class="ml-1 input">
      @if (configName === 'Subject') {
        <div>
          Select Organization:
        </div>
      }
      @if (configName === 'Subject') {
        <select
          [(ngModel)]="orgID"
          class="rounded-md border-0 px-3.5 py-2 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6 ml-1"
          >
          @for (item of items; track item) {
            <option [value]="item.organization_id">
              {{item.name}}
            </option>
          }
        </select>
      }
      @if (configName === 'Unit') {
        <div>
          Select Subject:
          <!-- TODO have dropdown menu to select subject id -->
        </div>
      }
      @if (configName === 'Unit') {
        <select
          [(ngModel)]="subjectID"
          class="rounded-md border-0 px-3.5 py-2 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6 ml-1"
          >
          @for (item of items; track item) {
            <option [value]="item.subject_id">
              {{item.name}}
            </option>
          }
        </select>
      }
      @if (configName === 'Course') {
        <div>
          Select Unit:
        </div>
      }
      @if (configName === 'Course') {
        <select
          class="rounded-md border-0 px-3.5 py-2 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6 ml-1"
          [(ngModel)]="unitID"
          >
          @for (item of items; track item) {
            <option [value]="item.subject_id">
              {{item.name}}
            </option>
          }
        </select>
      }
      @if (configName === 'Course') {
        <div>
          Start:
        </div>
      }
      @if (configName === 'Course') {
        <input
          [(ngModel)]="startDate"
          type="date"
          class="rounded-md border-0 px-3.5 py-2 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6 ml-1"
          />
      }
      @if (configName === 'Course') {
        <div>
          End:
        </div>
      }
      @if (configName === 'Course') {
        <input
          [(ngModel)]="endDate"
          type="date"
          class="rounded-md border-0 px-3.5 py-2 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6 ml-1"
          />
      }
    </div>
    <div class="flex justify-end">
      <outline-button [marginRight]="true" (click)="cancelConfig()" text="Cancel" />
      <full-button (click)="submitConfig()" text="Submit" />
    </div>
  </div>
</div>
